import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import SecondCoachDialog from "./partial/second-coach-dialog";
import { SimpleButton } from "../simple-button";
import { injectIntl } from "react-intl";
import IconButton from "components/icon-button";
import Icon from "components/icon";
import { LinkWithIcon } from "components/link";
import { useImperativeTracking } from "components/tracking";

const SecondCoachButtonWithModal = ({ secondCoachUrl, onlyIcon = false, asButton = true, intl }) => {
  const [open, setOpen] = useState(false);
  const track = useImperativeTracking();

  const handleOpen = useCallback(
    e => {
      setOpen(true);
      track("opens second coach dialog");
      e.stopPropagation();
    },
    [track],
  );

  const handleClose = useCallback(
    e => {
      setOpen(false);
      track("closes second coach dialog");
      e.stopPropagation();
    },
    [track],
  );

  return (
    <>
      {onlyIcon && (
        <IconButton onClick={handleOpen}>
          <Icon name="sports" />
        </IconButton>
      )}
      {!onlyIcon && asButton && (
        <SimpleButton
          onClick={handleOpen}
          icon="sports"
          label={intl.formatMessage({ id: "source.interface.secondCoach" })}
        />
      )}
      {!onlyIcon && !asButton && (
        <LinkWithIcon
          onClick={handleOpen}
          iconName="sports"
          text={intl.formatMessage({ id: "source.interface.secondCoach" })}
        />
      )}
      <SecondCoachDialog secondCoachUrl={secondCoachUrl} open={open} onClose={handleClose} />
    </>
  );
};

SecondCoachButtonWithModal.propTypes = {
  /**
   * Url de second coach
   **/
  secondCoachUrl: PropTypes.string,
  /**
   * Show as table icon
   **/
  onlyIcon: PropTypes.bool,
  /**
   * Show as button or as link
   **/
  asButton: PropTypes.bool,
};

export default injectIntl(SecondCoachButtonWithModal);
